import React, { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';

import { PromoIcon } from 'components/no-auth/common/promo-icon/PromoIcon';
import { PromoText } from 'components/no-auth/common/promo-text/PromoText';

import { useHandleCloseDropdownMenu } from 'hooks/useHandleCloseDropdownMenu';

import styles from './Dropdown.module.css';

export const Dropdown = (props) => {
    const wrapperRef = useRef(null);
    const [isOpenDropdownMenu, setOpenDropdownMenu] = useHandleCloseDropdownMenu(wrapperRef);
    const [placeholder, setPlaceholder] = useState(props.placeholder);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        if (props.selectedCategory !== 'all-articles') {
            const data = props.listItems.filter((item) => item.value === props.selectedCategory);
            setPlaceholder(data?.[0]?.title);
            setSelectedItem(data?.[0]?.value);
        }
    }, []);

    const inputContainerClassName = `${styles.inputContainer} ${props.isDisabled ? styles.disabled : ''}`;
    const dropdownListClassName = `${styles.dropdownList} ${props.label ? styles.hasLabel : ''}`;

    return (
        <div className={styles.dropdownContainer} ref={wrapperRef}>
            {props.label && (
                <div className={styles.label}>
                    <PromoText variant="note" color="gray80">
                        {props.label}
                    </PromoText>
                </div>
            )}
            <div className={inputContainerClassName} onClick={() => setOpenDropdownMenu(true)}>
                <div className={styles.placeholder}>
                    <PromoText tag="div" color={selectedItem ? 'gray80' : 'gray40'}>
                        {placeholder}
                    </PromoText>
                </div>
                <PromoIcon name="chevron-down" color="gray80" size="24px" />
            </div>
            {isOpenDropdownMenu && (
                <div className={dropdownListClassName}>
                    {props.listItems.map((item, index) => (
                        <div className={`${styles.dropdownItem} ${selectedItem === item.value ? styles.selected : ''}`} key={index}>
                            <PromoText tag="link" variant="link" href={`${props.link}/category/${item.value}`} color="gray80">
                                <h2>{item.title}</h2>
                            </PromoText>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

Dropdown.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    isDisabled: PropTypes.bool,
    listItems: PropTypes.array,
};
